import { useEffect, useRef, useState } from "react";
import { sounds } from "../../lib/sounds";

// Fuse ring: starts at top dead centre, the lit arc grows CLOCKWISE as time elapses, and its colour
// slides from green through amber to red as the head approaches top dead centre again (time's up).
const hueFor = (elapsed) => 120 * (1 - Math.min(1, Math.max(0, elapsed)));

export const TimerRing = ({ deadline, totalMs, serverNow, size = 76, graceMs = 5000, beep = false }) => {
  const [elapsed, setElapsed] = useState(0);
  const lastBeep = useRef(null);
  useEffect(() => {
    const id = setInterval(() => {
      const left = deadline - serverNow();
      setElapsed(Math.min(1, Math.max(0, 1 - left / totalMs)));
      if (beep && left > 0 && left <= graceMs) {
        const sec = Math.ceil(left / 1000); // 5,4,3,2,1 — one beep per second
        if (lastBeep.current !== sec) { lastBeep.current = sec; sounds.beep(sec <= 2); }
      }
    }, 100);
    return () => clearInterval(id);
  }, [deadline, totalMs, serverNow, beep, graceMs]);
  const r = size / 2 - 3;
  const circ = 2 * Math.PI * r;
  const pending = deadline - serverNow() > totalMs; // deal still in flight: the clock hasn't started yet
  const urgent = (1 - elapsed) * totalMs <= graceMs;
  const color = `hsl(${hueFor(elapsed)}, 85%, 50%)`;
  const head = 2 * Math.PI * elapsed - Math.PI / 2;
  return (
    <svg data-testid="turn-timer-ring" data-urgent={urgent} data-pending={pending} data-elapsed={elapsed.toFixed(2)} width={size} height={size} className="absolute -inset-[5px]" style={{ filter: `drop-shadow(0 0 6px ${color})`, opacity: pending ? 0 : 1, transition: "opacity 300ms" }}>
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="4" />
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth="4" strokeDasharray={circ}
        strokeDashoffset={circ * (1 - elapsed)} strokeLinecap="round" transform={`rotate(-90 ${size / 2} ${size / 2})`}
        style={{ transition: "stroke-dashoffset 100ms linear, stroke 300ms" }} />
      <circle cx={size / 2 + r * Math.cos(head)} cy={size / 2 + r * Math.sin(head)} r="4" fill="#fff" className={urgent ? "fuse-spark" : ""} />
    </svg>
  );
};
